import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=0da1298f"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da1298f')) {
      api.createRecord('0da1298f', component.options)
    } else {
      api.reload('0da1298f', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=0da1298f", function () {
      api.rerender('0da1298f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/menuItem.vue"
export default component.exports